import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthGuard} from './shared/guards/auth.guard';
import {ROUTES} from './shared/models/navigation';
import {WrapperComponent} from './shared/modules/wrapper/wrapper.component';

const routes: Routes = [
  {
    path: '',
    component: WrapperComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: ROUTES.CORPORATE,
        loadChildren: () => import('./corporate/corporate.module').then(m => m.CorporateModule)
      },
      {
        path: ROUTES.SPACES,
        loadChildren: () => import('./spaces/spaces.module').then(m => m.SpacesModule)
      },
      {
        path: ROUTES.USERS,
        loadChildren: () => import('./users/users.module').then(m => m.UsersModule)
      },
      {
        path: ROUTES.DOMAINS,
        loadChildren: () => import('./domains/domains.module').then(m => m.DomainsModule)
      },
      {
        path: '',
        redirectTo: ROUTES.SPACES,
        pathMatch: 'full'
      }
    ]
  },
  {
    path: ROUTES.NOT_FOUND,
    loadComponent: () =>
      import('./shared/modules/not-found/not-found.component').then(m => m.NotFoundComponent)
  },
  {
    path: '**',
    redirectTo: ROUTES.NOT_FOUND
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
